import B2BManage from "./B2BManage";

export default B2BManage;
